import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Mission} from '../Models/mission.model';
import {CallApi, HTTP_COMMAND} from "./callApi";


@Injectable()
export class ClientService {

constructor(private callApi: CallApi) {

  }

  //Used for Directory
  getClientList = (): Observable<Mission[]> => {
    return this.callApi.call(HTTP_COMMAND.GET, '/admin/clients/');
  }
}
